export const ADD_NOTIFICATION                  = 'ADD_NOTIFICATION';
export const DELETE_NOTIFICATION               = 'DELETE_NOTIFICATION';
export const FETCH_NOTIFICATION_FAILURE               = 'FETCH_NOTIFICATION_FAILURE';
export const FETCH_NOTIFICATION_SUCCESS               = 'FETCH_NOTIFICATION_SUCCESS';
export const FETCH_NOTIFICATION_REQUEST               = 'FETCH_NOTIFICATION_REQUEST';